import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import UitkListContext from "./uitk-list.js";
import { UitkListBullets, UitkListOrientations, UitkListSizes, UitkListItemThemes } from "./types.js";
export function UitkListItem({
  children,
  theme,
  ...attributes
}) {
  const context = React.useContext(UitkListContext);
  const { bullet, orientation, size, type } = context;
  const bulletClass = () => {
    let value;
    if (bullet && type) {
      value = UitkListBullets.get(bullet) === "bullet-default" ? `bullet-${type}` : UitkListBullets.get(bullet);
    }
    return value;
  };
  const baseClass = "uitk-typelist-item";
  const bulletBaseClass = `${baseClass}-bulletchar`;
  const cssClassNames = classNames(
    baseClass,
    `${baseClass}-${bulletClass()}`,
    bullet && bullet.includes("icon") && `${baseClass}-bullet-icon`,
    orientation && `${baseClass}-${UitkListOrientations.get(orientation)}`,
    size && `${baseClass}-${UitkListSizes.get(size)}`,
    bullet && !bullet.includes("icon") && theme && `${baseClass}-${UitkListItemThemes.get(theme)}`,
    bullet && bullet.includes("icon") && theme && `${baseClass}-bullet-icon-${UitkListItemThemes.get(theme)}`
  );
  const bulletCssClassNames = classNames(
    bulletBaseClass,
    `${bulletBaseClass}-${bulletClass()}`,
    size && `${bulletBaseClass}-${UitkListSizes.get(size)}`
  );
  const bulletMarkup = bullet && UitkListBullets.get(bullet) === "bullet-default" ? /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true", className: bulletCssClassNames }) : null;
  const wrappedChildren = bulletMarkup ? /* @__PURE__ */ React.createElement("span", { className: `${baseClass}-child` }, children) : children;
  return children ? (
    // Disabling the following rule. The role was added in #2287
    /* @__PURE__ */ React.createElement("li", { className: cssClassNames, ...attributes, role: "listitem" }, bulletMarkup, wrappedChildren)
  ) : null;
}
;
UitkListItem.displayName = "UitkListItem";
